export class QuestInfoModel {
  constructor(
    public id = 0,
    public travelpathwayid = 0,
    public homecompanyname = "",
    public destcompanycode = "",    
  ) { }
}
